/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAboveAveragePriceModule
 * Purpose		: Module for ProductsAboveAveragePrice.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { ProductsAboveAveragePriceService } from './ProductsAboveAveragePrice.service';
import { ProductsAboveAveragePriceListComponent } from './ProductsAboveAveragePriceList.component';
import { ProductsAboveAveragePriceSearchComponent } from './ProductsAboveAveragePriceSearch.component';
import { ProductsAboveAveragePriceDetailsComponent } from './ProductsAboveAveragePriceDetails.component';

import { ProductsAboveAveragePriceRoutingModule } from './ProductsAboveAveragePrice-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    ProductsAboveAveragePriceRoutingModule
  ],
  declarations: [
    ProductsAboveAveragePriceListComponent,
	ProductsAboveAveragePriceSearchComponent,
	ProductsAboveAveragePriceDetailsComponent
  ],
  providers: [
    ProductsAboveAveragePriceService
  ]
})

export class ProductsAboveAveragePriceModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductsAboveAveragePrice/ProductsAboveAveragePrice.module.ts